define('drops/multiSelect/multiSelect',[
    'jquery',
    'lq/drop',
    'lq/style',
    'lq/util',
    'underscore',
    'drops/multiSelect/checkboxList',
    'drops/multiSelect/dropDownMultiSelect',
    'lq/required'
], function ($, Drop, Style, util, _, Checkboxlist, DropDownMultiSelect, Required) {
    'use strict';

    var defaults = {
        data: {
            hiddenColumns: [],
            idOutput: 'Id',
            numberOfColumns: 1,
            addAllOption: false,
            allOptionLabel: 'All',
            useBuiltInStyle: true,
            required: {
                initialVisibility: true,
                isRequired: false,
                valueSource: 'hardcoded'
            },
            selectAllByDefault: false,
            placeholder: ''
        }
    };

    function MultiSelect(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        this.defaultStyleSettings = {
            text: { verticalAlign: 'middle' }
        };

        this.data.eventing = util.convertListOfKeyValuesToObject(this.data.eventing);

        this.checkedItemIds = [];
        this.items = null;
        this.columns = null;

        this.$element
            .attr('id', this.rootDrop.instanceId + '_' + this.data.id)
            .attr('tabindex', this.data.tabIndex)
	        .addClass('boxToBorderSize drop-text-container')
	        .css({
	            whiteSpace: 'pre-wrap'
	        });

        this.createControl();
        this.renderStyles();
    };

    Drop.extend(MultiSelect, Drop);

    MultiSelect.typeName = 'MultiSelect';

    MultiSelect.prototype.supportsManyToManyData = function () {
        return true;
    };

    MultiSelect.prototype.createControl = function () {
        if (this.data.isNormalDropdown)
            this.control = new DropDownMultiSelect(this);
        else
            this.control = new Checkboxlist(this);
    };

    MultiSelect.prototype.renderStyles = function () {
        Style.renderStyles(this, null, this.$element);
    };

    MultiSelect.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.piping.required.apply(this);

        var self = this;
        this.piping.datasources.registerDatasourceListener(this.data.dataSource, function (data) {
            self.control.setItems(data.results, data.outputs);
        });
        Required.prototype.addRemoveRequiredIndicator(self);
        this.applyPosition();
    };

    MultiSelect.prototype.postRender = function () {
        this.renderControl();
    };

    MultiSelect.prototype.renderControl = function () {
        this.control.render();
    };

    MultiSelect.prototype.getValue = function () {
        return this.control.getValue();
    };

    MultiSelect.prototype.clearValue = function () {
        this.control.clear();
    };

    MultiSelect.prototype.setValue = function (update) {
        this.control.setValue(update.value);
    };

    MultiSelect.prototype.unsubscribeEventHandlers = function () {
        this.control.dispose();
    };

    return MultiSelect;
});
